import { render, staticRenderFns } from "./MessageTreatment.vue?vue&type=template&id=88af6a6c&"
import script from "./MessageTreatment.vue?vue&type=script&lang=ts&"
export * from "./MessageTreatment.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTreatment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports